import React, { Component } from 'react';
import HeaderModalStores from './HeaderModalStores';

class ModalDetailsStoreLocation extends Component {
  removeTags = (str) => {
    if ((str === null) || (str === '')) {
      return '';
    }
    const strNew = str.toString();

    return strNew.replace(/(<([^>]+)>)/ig, '');
  }

  setHtmlDataServices = services => (
      <ul>{this.sanitizeHtml(services)}</ul>
  );

  render() {
    const { data, withReturn, hideOverlay } = this.props;
    const { storeName, address, services = '', schedule } = data;

    const {
      street,
      exteriorNumber,
      colony,
      zipCode,
      state = '',
      stateName = '',
      country = 'México',
      deligationOrCity,
      phoneNumber,
    } = address || {};

    const formatSchedule = scheduleDate => (scheduleDate.toUpperCase().includes('HORARIO')
      ? scheduleDate.split('Horario')
      : scheduleDate);

    const formatServices = list => list.split(',');

    const formatPhoneNumber = (phoneNumberString) => {
      const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
      }
      return null;
    };

    const sanitizeData = /li>/g.test(services);
    const resultDataServices = sanitizeData
      ? this.setHtmlDataServices(services.replace(/\n/g, ''))
      : (<ul>
        {
          formatServices(
            this.removeTags(services)).map(item => (<li>{item}</li>))
        }
      </ul>);

    return (
      <section className="modalContainerStores" style={{ maxHeight: '560px' }}>
        <HeaderModalStores
          titleHeaderMod={storeName}
          withReturn={() => withReturn(true, false)}
          closeModal={hideOverlay}
        />
        <section className="modalContainerContentStores" style={{ padding: 32 }}>
          <div>
            <p>Dirección</p>
            <p>{street && `${street} `} {exteriorNumber && `#${exteriorNumber}`}</p>
            <p>
              {colony && `Col. ${colony},`}{zipCode && ` C.P: ${zipCode}`}
            </p>
            <p>
              {`${state || stateName} ${country} ${deligationOrCity}`}
            </p>
            <p>
              {phoneNumber && `Tel: ${formatPhoneNumber(phoneNumber)}`}
            </p>
            <p>
              {/* {moduloDeCnc && `Horario ${formatSchedule(this.removeTags(moduloDeCnc))[1]}`} */}
              {schedule &&
                `Horario ${Array.isArray(formatSchedule(schedule)) ? formatSchedule(schedule)[1] : schedule}`
              }
            </p>
          </div>

          <div>
            <p> Servicios: </p>
            { resultDataServices }
          </div>
        </section>
      </section>
    );
  }
}

export default ModalDetailsStoreLocation;
